import AuthService from "./AuthService"
import ApiService from "./ApiService";

class FavoritesService extends ApiService{
    constructor(authService) {
        super();
        this._authService = authService;
        this._listUrl = '/favorites';
        this._profileListUrl = '/profile/favorites';
        this._updateUrl = '/favorites/update';
    }

    getBaseHeaders() {
        const langHeader = this._locale ? {'X-Localization' : this._locale} : {};
        const authHeader = this._authService.getAuthHeader();

        return {...authHeader, ...langHeader};
    }

    getList() {
        return this.postResource(this._listUrl, {}, this._authService.getAuthHeader());
    }

    getProfileList(filters, page) {
        return this.postResource(this._profileListUrl, {filters, page}, this.getBaseHeaders());
    }

    updateList(id) {
        const params = {id: id};

        return this.postResource(this._updateUrl, params, this._authService.getAuthHeader());
    }
}

const service = new FavoritesService(AuthService);

export default service;
